import axios from 'axios';
import { Theme, useMediaQuery } from '@mui/material';
import { UserTypology } from 'helpers/Enums';
import { createContext, useEffect, useState } from 'react';

interface IappUserContext {
    hasLoaded: boolean
    isAuthorized: boolean
    isMobile: boolean
    currentUser: IUser

    signOut: () => Promise<void>
}

export let appUserContext = createContext({} as IappUserContext);

interface IUser {
    userId: string
    isAuthorized: boolean
    firstName: string
    lastName: string
    fullName: string
    email: string
    typology: UserTypology
    simecClaims: SimecClaim
    customerClaims: CustomerClaim
}

interface SimecClaim {
    canCreateTicket: boolean
    canBeReporter: boolean
    canDeleteTicket: boolean
    canViewTicket: boolean
    canWorkOnAllTickets: boolean
    canWorkOnMyTickets: boolean
    canWorkOnTicketForMyGroup: boolean
    cannotWorkOnTickets: boolean
    canBeAssignedToTicket: boolean
    canGoToCustomer: boolean
    canManageCustomerUsers: boolean
    canManageSimecUsers: boolean
    canManageTicketCategories: boolean
    canManageToolTypologies: boolean
    canViewScheduling: boolean
    canEditScheduling: boolean
    canViewSummary: boolean
    canManageCanGoToCustomerSimecUsers: boolean
    canLoginAs: boolean
    canManageTicketInbox: boolean
    canManageTools: boolean
    canViewDashboard: boolean
    isSubscribedToTicketDoneNotifications: boolean
}

interface CustomerClaim {
    isAdmin: boolean
    customerId: string
    customerName: string
}

let { Provider } = appUserContext;

let AppUserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    
    const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

    let [hasLoaded, setHasLoaded] = useState(false);
    let [isAuthorized, setAuthorized] = useState(false);
    let [currentUser, setCurrentUser] = useState<IUser>({} as IUser);

    useEffect(() => {
        getUserConfigurations();
    }, [])


    let getUserConfigurations = async () => {
        try {
            setHasLoaded(false);

            let res = await axios.get('/api/Auth/CurrentUser');
            let { item } = res.data;
            setCurrentUser(item);
            setAuthorized(item.isAuthorized);
            setHasLoaded(true);

        } catch (err) { }
    }

    let signOut = async () => {
        try {
            await axios.post('/api/Auth/Logout');
            window.location.href = '/Identity/Account/Login';
        } catch (err) { }
    }


    return (
        <Provider
            value={{
                hasLoaded,
                isMobile,
                isAuthorized,
                currentUser,

                signOut
            }}
        >
            {children}
        </Provider>
    )
}

export default AppUserProvider;